<wl-experience-editor>
  <ng-template wlLive>
    @if (backLink$ | async; as backLink) {
      <div class="d-lg-none">
        <a
          wlAutomationId="back-button-mobile"
          class="mobile-back-button btn btn-outline-secondary btn-sm"
          [class.btn-icon]="!backLink.title"
          *wlGenericLink="backLink; extras: { queryParamsHandling: 'preserve' }"
          [wlTrackLink]="backLink.title"
          [trackLinkInfo]="{
            rendering: rendering,
            field: backLink.title,
            linkurl: backLink.href,
          }"
          wlCSCapture
        >
          <fa-icon
            [class.me-1]="backLink.title"
            icon="arrow-left"
            size="lg"
          ></fa-icon>
          <span>{{ backLink?.title }}</span>
        </a>
      </div>
    }
  </ng-template>
  <ng-template wlPreview>
    @if (backLink$ | async; as backLink) {
      <fa-icon class="me-1" icon="arrow-left" size="lg"></fa-icon>
      <span
        >Mobile terugkeerknop (stel deze in door "backUrl" op de pagina in te
        vullen)</span
      >
    }
  </ng-template>
</wl-experience-editor>
